export default __webpack_public_path__ + "assets/ico_rule_off_btn-728f21f0.svg";